import React from 'react'
import useSmoothscrollPolyfill from 'UTILS/smoothscroll-polyfill'

interface WithRootProps {}

const withRoot = (Component: React.ElementType) => {
  const WithRoot: React.FC<WithRootProps> = (props) => {
    useSmoothscrollPolyfill()

    return <Component {...props} />
  }

  return WithRoot
}

export default withRoot
